<template>
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
  
        <!-- title text and switch button -->
        <div class="text-center">
            <b-img thumbnail :src='order.logo' fluid />
          <b-link class="brand-logo">
            
            <h2 class="brand-text">
                {{ order.client_name }}
            </h2>
          </b-link>
            <h1 class="m-1">
                付款細節
            </h1>
        </div>
        <!--/ title text and switch button -->
    
        <!-- pricing plan cards -->
        <b-row class="pricing-card">
            <b-col sm="12" md="12" lg="12" class="mx-auto">
                <b-overlay :show="processing" :opacity="'0.95'">
                <b-row>
                    <b-col>
                        <b-card>
                             <h4>
         
                            付款編號 <br><span style="font-size:0.95rem">{{ order.uuid }}</span><br><br>
                            付款金額 <br><span style="font-size:0.95rem">HKD ${{ order.amount }}</span><br><br>
                            付款方式 <br><span style="font-size:0.95rem">ONLINE PAYMENT</span><br><br>
                            結果<br><span style="font-size:0.95rem"><b-badge class="px-2" :variant="(order.result).toLowerCase()">{{ order.result }}</b-badge></span><br><br>
                            </h4>
                            <hr>
                            如有任何付款問題, 歡迎立即聯絡我們～

                        </b-card>
                        
                    </b-col>
                </b-row>
            </b-overlay>
            </b-col>
        </b-row>
    
    </div>
    </div>
    </template>
    
    <script>
    import {
        BFormCheckbox,
        BOverlay,
        BRow,
        BCol,
        BCard,
        BModal,
        BImg,
        BCardText,
        BListGroup,
        BListGroupItem,
        BButton,
        BBadge,
        BInputGroup,
        BFormInput,
        BForm,
        BFormGroup,
        BInputGroupAppend,
        BInputGroupPrepend,
        BCollapse,
        VBToggle
    } from 'bootstrap-vue'
    import router from '@/router'
    import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
    import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
    import Ripple from 'vue-ripple-directive'
    /* eslint-disable global-require */
    export default {
        components: {
            BFormCheckbox,
            router,
            BOverlay,
            BButton,
            BCardText,
            VBToggle,
            BListGroup,
            ToastificationContent,
            BListGroupItem,
            BCollapse,
            BFormGroup,
            BInputGroup,
            BFormInput,
            BInputGroupAppend,
            BInputGroupPrepend,
            BForm,
            BRow,
            BCol,
            BModal,
            BCard,
            BBadge,
            BImg,
            AppCollapseItem,
            AppCollapse,
        },
        directives: {
            Ripple,
            'b-toggle': VBToggle,
        },
        data() {
            return {
                order_id : router.currentRoute.params.order_id,
                success : false,
                processing: true,
                order: {
                    order_id : '',
                    amount : "",
                    result : "",
                    txamt : 0,
                    payment_type: ""
                },
                timer: null
            }
        },
        created() {
            this.check()
            this.test()
        },
        methods: {
            test() {
                this.timer = setInterval(() => {
                    this.check()
                }, 3000)
            },
            check() {
                this.$http.get(process.env.VUE_APP_API_BASE+'/payment_gateway/check/' + this.order_id + '/' )
                    .then(res => {
                        if (res.data.order.result == 'SUCCESS') { 
                            this.order.payment_type = "ONLINE PAYMENT"
                            this.processing = false
                            clearInterval(this.timer)
                            switch (res.data.order.gateway) {
                                case "stripe":
                                    this.order = res.data.stripe
                                    break;
                                case "free":
                                case "qfpay":
                                    this.order = res.data.order
                                    console.log(this.order)
                                    break;
                            }
                        }
                    })
                },
        },
    }
    /* eslint-disable global-require */
    </script>
    
    <style lang="scss">
    @import '@core/scss/vue/pages/page-pricing.scss';
    </style>
    